<template>
  <b-container>
    <b-card>
      <b-form @submit.prevent="save()">
        <b-row>
          <b-col sm="12" lg="6">
            <b-form-group label-for="name">
              <template #label>
                Name
                <span class="text-danger">&nbsp;*</span>
              </template>
              <b-form-input id="name" v-model="form.name" required />
            </b-form-group>
          </b-col>
          <b-col sm="12" lg="6">
            <b-form-group label-for="username_field">
              <template #label>
                Username
                <span class="text-danger">&nbsp;*</span>
              </template>
              <b-form-input id="username_field" v-model="form.username" required :disabled="isEdit" />
            </b-form-group>
          </b-col>
          <b-col sm="12" lg="6">
            <b-form-group label-for="email_field">
              <template #label>
                Email
                <span class="text-danger">&nbsp;*</span>
              </template>
              <b-form-input
                id="email_field"
                v-model="form.email"
                type="email"
                required
              />
            </b-form-group>
          </b-col>
          <b-col sm="12" lg="6">
            <b-form-group label-for="password_field">
              <template #label>
                Password
                <span class="text-danger">&nbsp;*</span>
              </template>
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="password_field"
                  v-model="form.password"
                  class="form-control-merge"
                  :type="'text'"
                  name="password"
                />
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col sm="12" lg="6">
            <b-form-group label-for="password_field">
              <template #label>
                Position
                <span class="text-danger">&nbsp;*</span>
              </template>
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="position_field"
                  v-model="form.jabatan"
                  class="form-control-merge"
                  :type="'text'"
                  name="position"
                />
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col sm="12" lg="6">
            <b-form-group label-for="password_field">
              <template #label>
                Division
                <span class="text-danger">&nbsp;*</span>
              </template>
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="division_field"
                  v-model="form.division"
                  class="form-control-merge"
                  :type="'text'"
                  name="division"
                />
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="6">
            <b-form-group>
                Role <span class="text-danger">*</span>
                <v-select
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="availableRole"
                v-model="form.role"
                />
            </b-form-group>
          </b-col>
          <b-col sm="12" md="3">
            <b-form-group>
                Always Sync <span class="text-danger">*</span>
                <v-select
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="optionsSync"
                v-model="form.alwaysSync"
                label="label"
                />
            </b-form-group>
            <b-form-group>
              Allow Backdate Reservation
              <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="optionsAllowBackdateReservation"
              v-model="form.ALLOW_BACKDATE_RESERVATION"
              label="label"
            />
            </b-form-group>
          </b-col>
          <b-col sm="12">
            <!-- <b-form-group label="Organic" label-for="organic">
              <b-form-checkbox
                id="organic"
                v-model="form.is_organic"
                :unchecked-value="false"
                switch
              />
            </b-form-group> -->
          </b-col>
          <b-col class="d-flex justify-content-end">
            <b-button type="button" @click.prevent="$router.push({name: 'admin-users-index'})" class="mr-1" variant="light">
              Cancel
            </b-button>
            <b-button type="submit" :disabled="isLoading" variant="primary">
              Save
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
  </b-container>
</template>

<script>
import {
  BRow,
  BCol,
  BContainer,
  BFormGroup,
  BCard,
  BFormInput,
  BButton,
  BForm,
  BFormCheckbox,
  BInputGroup,
  BInputGroupAppend,
} from 'bootstrap-vue'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'

import vSelect from 'vue-select'

export default {
  components: {
    BRow,
    BCol,
    BContainer,
    BFormGroup,
    BCard,
    BFormInput,
    BButton,
    BForm,
    BFormCheckbox,
    BInputGroup,
    BInputGroupAppend,
    vSelect,
  },

  mixins: [togglePasswordVisibility],

  data() {
    return {
      isLoading: false,
      availableRole: [
        'approver',
        'admin',
        'telkom a',
        'telkom b',
      ],
      optionsSync: [
        {label: 'Yes', value: true}, 
        {label: 'No', value: false}
      ],
      optionsAllowBackdateReservation: [
        {label: 'Yes', value: true}, 
        {label: 'No', value: false}
      ],
      form: {
        name: '',
        username: '',
        email: '',
        password: '',
        // is_organic: false,
        role: '',
        jabatan: '',
        division: '',
        alwaysSync: {},
        ALLOW_BACKDATE_RESERVATION: { label: 'No', value: false }
      },
    }
  },

  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    paramID() {
      return this.$route.params.key
    },
    isEdit(){
      if (this.paramID) {
        return true
      } 
      return false
    },
    isAdmin() {
        let role = this.$store.getters['oauth/getActiveUser'].role
        if (!role.includes('admin')) {
            return false
        }
        return true
    },
  },
  mounted() {
    if (this.isEdit) {
      this.getUser()
    }
  },
  methods: {
    addUser() {
      this.isLoading = true
      let formToUpload = {
        ...this.form,
        role: this.form.role,
        sync: this.form.alwaysSync.value,
        allow_backdate_reservation: this.form.ALLOW_BACKDATE_RESERVATION.value
      }
      this.$http
        .post('/user', formToUpload)
        .then(() => {
          this.$notif('Success', 'User has been successfully added.', 'success')
          this.$router.push({ name: 'admin-users-index' })
        })
        .catch(({ data }) => this.$notif('Error', `${data.message}`, 'error'))
        .finally(() => {
          this.isLoading = false
        })
    },
    updateUser() {
      this.isLoading = true
      let formToUpload = {
        ...this.form,
        role: this.form.role,
        sync: this.form.alwaysSync.value,
        allow_backdate_reservation: this.form.ALLOW_BACKDATE_RESERVATION.value

      }
      this.$http
        .put(`/user/${this.paramID}`, formToUpload)
        .then(() => {
          this.$notif('Success', 'User has been successfully updated.', 'success')
          this.$router.push({ name: 'admin-users-index' })
        })
        .catch(({ data }) => this.$notif('Error', `${data.message}`, 'error'))
        .finally(() => {
          this.isLoading = false
        })
    },
    async getUser() {
      return await this.$http.get(`/user/id/${this.paramID}/set/first`)
      .then(res => {
        let data = res.data.data.records
        this.form.name = data.NAME
        this.form.username = data.USERNAME
        this.form.email = data.EMAIL_ADDRESS
        this.form.jabatan = data.JABATAN
        this.form.division = data.DIVISION
        this.form.alwaysSync = this.optionsSync.filter(x => x.value == data.SYNC)
        this.form.ALLOW_BACKDATE_RESERVATION = 
          this.optionsAllowBackdateReservation.find(x => x.value == data.ALLOW_BACKDATE_RESERVATION) 
          || { value: false, label: 'No' }
        if (data.roles.length > 0) {
          this.form.role = data.roles[0]
        }
      })
    },
    save() {
      if (this.isEdit) {
        this.updateUser()
      } else {
        this.addUser()
      }
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>